import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { scrollToId } from "../hooks/useLenis";

const LINKS = [
  { id: "hero", label: "Αρχική" },
  { id: "about", label: "Σχετικά" },
  { id: "music", label: "Μουσική" },
  { id: "gallery", label: "Φωτογραφίες" },
  { id: "city", label: "Η Πόλη" },
  { id: "contact", label: "Επικοινωνία" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <motion.header
      data-testid="main-nav"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 2.0, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,padding] duration-500 ${
        scrolled
          ? "bg-[var(--bg)]/80 backdrop-blur-md border-b border-[var(--line)] py-4"
          : "bg-transparent border-b border-transparent py-6"
      }`}
    >
      <nav className="mx-auto max-w-[1500px] px-6 md:px-12 flex items-center justify-between drop-shadow-[0_1px_10px_rgba(233,243,252,0.6)]">
        <button
          data-testid="nav-logo"
          onClick={() => go("hero")}
          className="font-serif text-xl md:text-2xl tracking-[0.25em] text-[var(--fg)] hover:text-[var(--gold-ink)] transition-colors duration-300"
        >
          ΤΑΞΙΔΙΩΤΕΣ
        </button>

        <ul className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <li key={l.id}>
              <button
                data-testid={`nav-link-${l.id}`}
                onClick={() => go(l.id)}
                className="font-mono text-[11px] tracking-[0.25em] uppercase text-[var(--fg)] hover:text-[var(--gold-ink)] link-underline transition-colors duration-300"
              >
                {l.label}
              </button>
            </li>
          ))}
        </ul>

        <button
          data-testid="nav-toggle"
          className="md:hidden text-[var(--fg)]"
          onClick={() => setOpen((o) => !o)}
          aria-label="menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.ul
            data-testid="mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
            className="md:hidden overflow-hidden bg-[var(--bg)]/95 backdrop-blur-md mt-4 border-t border-[var(--line)]"
          >
            {LINKS.map((l) => (
              <li key={l.id} className="border-b border-[var(--line)]">
                <button
                  data-testid={`mobile-link-${l.id}`}
                  onClick={() => go(l.id)}
                  className="block w-full text-left px-6 py-5 font-serif text-2xl text-[var(--fg)]"
                >
                  {l.label}
                </button>
              </li>
            ))}
          </motion.ul>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
